import React from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

import { customAlert } from "./Components/Alert/alert.component";

const PrivateRoute = ({
  component: Component,
  currentUser,
  location,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (currentUser) {
          return <Component {...props} />;
        } else {
          customAlert("error", "Hummm!!", "You Must Logged In");
          return (
            <Redirect
              to={{
                pathname: "/",
                state: { from: location },
              }}
            />
          );
        }
      }}
    />
  );
};

const mapStateToProps = ({ user: { currentUser } }) => ({
  currentUser,
});

export default connect(mapStateToProps, null)(PrivateRoute);
